import { Component, OnInit, ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { BaseChartDirective, Color, Label, MultiDataSet, PluginServiceGlobalRegistrationAndOptions } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-yearly-cost',
  templateUrl: './yearly-cost.component.html',
  styleUrls: ['./yearly-cost.component.scss'],
})
export class YearlyCostComponent implements OnInit {
  @ViewChild('yearly') yearlyChart: BaseChartDirective;
  public randomizer: Subscription = new Subscription();

  public barChartOptions: ChartOptions = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales    : {
      xAxes: [{
        gridLines: {
          display: false
        },
        ticks    : {}
      }],
      yAxes: [
        {
          id       : 'y-axis-0',
          position : 'left',
          ticks    : {
            beginAtZero: true,
            max        : 100,
            min        : 0,
            stepSize   : 25
          },
          gridLines: {
            display: false
          }
        }
      ]
    },
    plugins   : {
      datalabels: {
        anchor: 'end',
        align : 'end',
      }
    },
    legend: {
      display: true,
      position: 'bottom'
    }
  };


  public barChartLabels: Label[]       = ['2017', '2018', '2019'];
  public barChartType: ChartType       = 'bar';
  public barChartLegend                = true;
  public barChartPlugins               = [];
  public barChartColors: Color[]       = [
    {backgroundColor: '#2b60ad'},
    {backgroundColor: '#765ca7'},
    {backgroundColor: '#e74699'},
  ];

  public barChartData: ChartDataSets[] = [
    { data: [50, 60, 75], label: '2017', barPercentage: 0.5, categoryPercentage: 0.3 },
    { data: [60, 80, 80], label: '2018', barPercentage: 0.5, categoryPercentage: 0.3 },
    { data: [60, 75, 90], label: '2019', barPercentage: 0.5, categoryPercentage: 0.3 },
  ];

  public initRandomizer() {
    // While we are on this page, randomize data
    this.randomizer = interval(1000).subscribe(() => {
      this.generateYearlyData();
    });
  }

  public generateYearlyData() {
    this.barChartData[0].data[2] = this.getRandomArbitrary(50, 99);
    this.barChartData[1].data[2] = this.getRandomArbitrary(50, 99);
    this.barChartData[2].data[2] = this.getRandomArbitrary(50, 99);
    this.yearlyChart.update();
  }

  private getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }

  constructor() { }

  ngOnInit() {
    this.initRandomizer();
  }

  ngOnDestroy(): void {
    this.randomizer.unsubscribe();
  }

}
